import React from 'react';
import { LoginView } from './login_view';

/**
 * ログイン画面
 * @param error
 * @constructor
 */
export const LoginPage: React.FC<{ error?: string }> = ({ error }) => {
  return (
    <LoginView errorMessage={error} />
  );
};
